var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('p',{staticClass:"Hero-Text",style:({
      'font-size': _vm.fontSize,
      'margin-left': _vm.marginLeft,
      width: _vm.width,
      'margin-top': _vm.marginTop,
    })},[_vm._v(" Laporan Keuangan "+_vm._s(_vm.$route.params.id)+" ")]),_c('img',{staticClass:"Hero",attrs:{"src":require("../../assets/SyaratKetentuan/Hero.png"),"srcset":require("../../assets/SyaratKetentuan/Hero@2x.png") + " 2x, " + require("../../assets/SyaratKetentuan/Hero@3x.png") + " 3x"}}),_c('v-col',{staticClass:"pdfContainer mx-auto"},_vm._l((10),function(i){return _c('v-img',{key:i,staticClass:"LaporanKeuangan mx-auto",attrs:{"src":require('../../assets/InformasiLainnya/' +
          _vm.$route.params.id +
          '/report-' +
          i +
          '.jpg')}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }